import { GlobalOutlined } from "@ant-design/icons";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { GlobalStore } from "../store/store";
import { Button, Col, Row } from "antd";
import { GiBrazilFlag } from "react-icons/gi";

interface IIntlButtonsProps {
  store: GlobalStore;
};

export const IntlButtons: FC<IIntlButtonsProps> = observer(({ store }) => {
  const color_1 = store.currency === "brl" ? "#4096ff" : undefined;
  const color_2 = store.currency === "usd" ? "#4096ff" : undefined;

  return (
    <Row gutter={8} style={{ margin: 0 }}>
      <Col md={12}>
        <Button
          onClick={() => store.setCurrency("brl")}
          title="Brasil"
          type={store.currency === "brl" ? "default" : "dashed"}
          style={{ color: color_1, borderColor: color_1 }}
        >
          Brasil <GiBrazilFlag />
        </Button>
      </Col>
      <Col md={12}>
        <Button
          onClick={() => store.setCurrency("usd")}
          title="International"
          type={store.currency === "usd" ? "default" : "dashed"}
          style={{ color: color_2, borderColor: color_2 }}
        >
          Global <GlobalOutlined />
        </Button>
      </Col>
    </Row>
  );
}
)